export default {
  'menu.zy-hr.workbench': '工作台',
  'menu.zy-hr.dashboard': '人事看板',
  'menu.zy-hr.employeeCenter': '员工中心',
  'menu.zy-hr.employeeWorkbench': 'HR工作台',
  'menu.zy-hr.employee': '员工花名册',
  'menu.zy-hr.employee.recycleBin': '员工回收站',
  'menu.zy-hr.employee.detail': '员工详情',
  'menu.zy-hr.me': '我的工作台',
  'menu.zy-hr.onboarding': '待入职',
  'menu.zy-hr.regularization': '转正',
  'menu.zy-hr.employeeChange': '员工异动',
  'menu.zy-hr.profileChange': '自助资料变更',
  'menu.zy-hr.employeeLifecycleAudits': '生命周期审计',
  'menu.zy-hr.certificateRequests': '证明申请',
  'menu.zy-hr.employeeRelationsAnalysis': '员工关系分析',
  'menu.zy-hr.employeeCenterSettings': '员工中心设置',
  'menu.zy-hr.employeePortalSettings': '员工端设置',
  'menu.zy-hr.resignation': '离职',
  'menu.zy-hr.laborRelations': '劳动关系',
  'menu.zy-hr.attendanceCenter': '考勤中心',
  'menu.zy-hr.payrollCenter': '薪酬中心',
  'menu.zy-hr.payroll.workbench': '薪酬工作台',
  'menu.zy-hr.payroll.plans': '薪资方案',
  'menu.zy-hr.payroll.items': '薪资项目',
  'menu.zy-hr.payroll.profiles': '员工薪资档案',
  'menu.zy-hr.payroll.deductions': '扣缴结果',
  'menu.zy-hr.payroll.adjustments': '调薪管理',
  'menu.zy-hr.payroll.runs': '算薪批次',
  'menu.zy-hr.payroll.slips': '薪资台账',
  'menu.zy-hr.socialInsuranceCenter': '社保中心',
  'menu.zy-hr.socialInsurance.workbench': '社保工作台',
  'menu.zy-hr.socialInsurance.policies': '参保方案',
  'menu.zy-hr.socialInsurance.accounts': '参保档案',
  'menu.zy-hr.socialInsurance.changes': '增减员管理',
  'menu.zy-hr.socialInsurance.bills': '缴费台账',
  'menu.zy-hr.performanceCenter': '绩效中心',
  'menu.zy-hr.performance.cycles': '绩效周期',
  'menu.zy-hr.performance.goals': '绩效目标',
  'menu.zy-hr.performance.reviews': '绩效评估',
  'menu.zy-hr.performance.interviews': '绩效面谈',
  'menu.zy-hr.performance.results': '绩效结果',
  'menu.zy-hr.performance.gradeRules': '等级规则',
  'menu.zy-hr.trainingLearningCenter': '培训学习中心',
  'menu.zy-hr.careerPlanning': '职业规划',
  'menu.zy-hr.talentInventory': '人才盘点',
  'menu.zy-hr.foundationConfig': '基础配置',
  'menu.zy-hr.processReminder': '流程与提醒',
  'menu.zy-hr.approval': '待我审批',
  'menu.zy-hr.approvalRecords': '审批记录',
  'menu.zy-hr.approvalAbnormalRecords': '异常审批记录',
  'menu.zy-hr.approvalDelegates': '审批代理',
  'menu.zy-hr.approvalHandovers': '审批交接',
  'menu.zy-hr.approvalInstances': '审批实例',
  'menu.zy-hr.approvalTemplates': '审批模板',
  'menu.zy-hr.organization.unit': '组织管理',
  'menu.zy-hr.organization.position': '岗位管理',
  'menu.zy-hr.organization.jobLevel': '职级管理',
  'menu.zy-hr.organization.workLocation': '工作地点',
  'menu.zy-hr.organization.employeeTag': '员工标签',
  'menu.zy-hr.organization.roles': '角色权限',
  'menu.zy-hr.organization.permissions': '权限码维护',
  'menu.zy-hr.attendance.workbench': '考勤工作台',
  'menu.zy-hr.attendance.shifts': '班次库',
  'menu.zy-hr.attendance.groups': '考勤组',
  'menu.zy-hr.attendance.schedules': '排班日历',
  'menu.zy-hr.attendance.holidayPlans': '假期方案',
  'menu.zy-hr.attendance.record': '考勤记录',
  'menu.zy-hr.attendance.daily': '日考勤结果',
  'menu.zy-hr.attendance.monthly': '月考勤表',
  'menu.zy-hr.attendance.leaveBalances': '假期余额',
  'menu.zy-hr.attendance.leaveGrantPolicies': '假期发放规则',
  'menu.zy-hr.attendance.leave': '请假申请',
  'menu.zy-hr.attendance.overtime': '加班申请',
  'menu.zy-hr.attendance.punch': '补卡申请',
  'menu.zy-hr.attendance.setting': '考勤设置',
  'menu.zy-hr.reminder': '人事提醒',
  'menu.zy-hr.systemUpdates': '系统更新',
  'menu.login': '登录',
  'menu.account.center': '个人中心',
  'menu.account.workbench': '回到工作台',
  'menu.account.tenantManagement': '企业管理',
  'menu.account.logout': '退出登录',
};
